// tslint:disable: max-classes-per-file
import { css } from 'emotion';
import { last } from 'lodash';
import { computed, observable } from 'mobx';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { Toast } from './Toast';

const toast = (isToastHidden: boolean) => css`
  ${isToastHidden ? 'opacity: 0;' : 'opacity: 1;'}
  transition: 0.25s ease-in-out;
`;

class ToastStore {
  @observable
  public messages: Array<string> = [];

  @observable
  public isToastHidden = true;

  @computed
  public get lastMessage() {
    return last(toastStore.messages);
  }
}

const toastStore = new ToastStore();

interface IToastContainerProps {
  className?: string;
}

export const ToastContainer = observer(({ className }: IToastContainerProps) => (
  <div className={className}>
    <Toast className={toast(toastStore.isToastHidden)} message={toastStore.lastMessage} />
  </div>
));

export function createToast(message: string) {
  toastStore.messages.push(message);
  toastStore.isToastHidden = false;

  setTimeout(() => {
    toastStore.isToastHidden = true;
    setTimeout(() => toastStore.messages.pop(), 230);
  }, 3000);
}
